module.exports = __webpack_public_path__ + "img/xj1.2aa90050.png";